// extracted by mini-css-extract-plugin
module.exports = {"waterMark":"Watermark_waterMark__1FozZ","containerImg":"Watermark_containerImg__17Giw"};